var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Checkbox, FormControl, FormControlLabel, FormGroup, TextField, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { MoreIcon, SearchIcon } from "../../../assets/images";
import { MuiStack } from "../../atoms/stackComponent";
var CheckboxFilters = function (props) {
    var itemsList = props.itemsList, onChange = props.onChange, valueExpr = props.valueExpr, value = props.value;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var _a = useState([]), filter = _a[0], setFilter = _a[1];
    var _b = useState([]), filterList = _b[0], setFilterList = _b[1];
    useEffect(function () {
        if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
            setFilter(value);
        }
    }, [value]);
    useEffect(function () {
        setFilterList(itemsList);
    }, [itemsList]);
    var handleChange = function (event) {
        var _filters = __spreadArray([], filter, true);
        if (filter.length > 0) {
            var found = filter === null || filter === void 0 ? void 0 : filter.find(function (item) { return item === event.target.name; });
            if (found) {
                _filters = filter === null || filter === void 0 ? void 0 : filter.filter(function (item) { return item !== event.target.name; });
            }
            else {
                _filters.push(event.target.name);
            }
        }
        else {
            _filters.push(event.target.name);
        }
        setFilter(_filters);
        onChange(_filters);
    };
    var isChecked = function (item) {
        var selected = filter === null || filter === void 0 ? void 0 : filter.find(function (i) { return i === item[valueExpr]; });
        if (selected) {
            return true;
        }
        else {
            return false;
        }
    };
    var handleOnChangeSearchInput = function (event) {
        var searchList = itemsList.filter(function (item) {
            var _event$target$value;
            return item[valueExpr].toLowerCase().includes((_event$target$value = event.target.value) === null || _event$target$value === void 0 ? void 0 : _event$target$value.toLowerCase());
        });
        setFilterList(searchList);
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        paddingX: lgMode ? 1 : 0
    }, /*#__PURE__*/ React.createElement(FormControl, {
        variant: "outlined",
        sx: {
            paddingRight: 1
        }
    }, /*#__PURE__*/ React.createElement(TextField, {
        size: "small",
        type: "search",
        placeholder: t("Search"),
        onChange: function (event) { return handleOnChangeSearchInput(event); },
        InputProps: {
            startAdornment: /*#__PURE__*/ React.createElement("img", {
                height: 20,
                width: 20,
                src: SearchIcon,
                style: {
                    marginRight: "6px"
                }
            }),
            endAdornment: /*#__PURE__*/ React.createElement("img", {
                height: 20,
                width: 20,
                src: MoreIcon
            })
        }
    })), /*#__PURE__*/ React.createElement(FormControl, {
        variant: "standard",
        sx: {
            margin: 0
        }
    }, /*#__PURE__*/ React.createElement(FormGroup, null, filterList === null || filterList === void 0 ? void 0 : filterList.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(FormControlLabel, {
            sx: {
                padding: 0,
                margin: 0
            },
            className: lgMode ? "none" : "border-bottom-custom",
            key: "mode-checkbox-".concat(index),
            control: /*#__PURE__*/ React.createElement(Checkbox, {
                checked: value.length > 0 && isChecked(item),
                onChange: handleChange
            }),
            name: item === null || item === void 0 ? void 0 : item[valueExpr],
            label: /*#__PURE__*/ React.createElement(Typography, {
                variant: "h4"
            }, item === null || item === void 0 ? void 0 : item.DisplayName)
        });
    }))));
};
export default CheckboxFilters;
